<template>
  <a-modal title="支付" :visible="visible" :footer="null" :width="600" @cancel="$emit('cancel')">
    <div class="w-full">
      <a-tabs v-model="activeKey">
        <a-tab-pane v-if="bank" :key="1" tab="网银支付">
          <div class="w-full text-center">
            <a-button type="primary" @click="gopay">去支付</a-button>
          </div>
        </a-tab-pane>
        <template v-if="info.temp">
          <a-tab-pane v-if="info.temp.is_pay" :key="3" tab="扫码支付"
            ><div class="flex items-center justify-around">
              <div
                class="flex flex-col items-center justify-around p-6"
                :style="{ minHeight: '250px' }"
              >
                <a-statistic
                  title="担保费"
                  :value="info.poundage"
                  prefix="￥"
                  :value-style="{ color: 'red' }"
                />
              </div>
              <div class="flex flex-col items-center justify-center p-6">
                <div id="qrcode" ref="qrcode" class="w-48 h-48"></div>
                <div class="py-2 pt-4 text-center">请使用微信或支付宝扫一扫</div>
                <div class="py-2 text-center text-red-500">请在{{ qrcodetime }}之前付款</div>
                <div><a-button type="primary" @click="reload">刷新二维码</a-button></div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane v-if="info.temp.is_point_pay" :key="4" tab="积分支付">
            <div class="flex flex-col items-center justify-around">
              <div class="flex items-center justify-around w-full p-6">
                <a-statistic
                  title="担保费"
                  :value="info.poundage"
                  prefix="￥"
                  :value-style="{ color: 'red' }"
                />
                <a-statistic
                  title="我的积分"
                  :value="userinfo.points"
                  :value-style="{ color: 'green' }"
                />
              </div>
              <div class="flex flex-col items-center justify-center p-6 pt-0">
                <a-button
                  type="primary"
                  :disabled="!points"
                  @click="pointspay"
                  :loading="payloading"
                  >{{ !points ? '积分不足' : '确认支付' }}</a-button
                >
              </div>
            </div></a-tab-pane
          >
        </template>
      </a-tabs>
    </div>
  </a-modal>
</template>

<script>
  import { contractCheck, contractThirdPay, contractPointPay } from '@/api/contract';
  import { userinfo2 } from '@/api/user';
  import { banks } from '@/api/bank';
  import QRCode from 'qrcodejs2';
  import dayjs from 'dayjs';
  export default {
    props: {
      visible: Boolean,
      info: Object,
    },
    data() {
      return {
        activeKey: 1,
        banklist: [],
        qrcodeurl: '',
        qrcodetime: '',
        payloading: false,
        ti: null,
        userinfo: {},
      };
    },
    computed: {
      bank() {
        if (this.info.bankName) {
          return this.banklist.find((e) => {
            return this.info.bankName.indexOf(e.name) >= 0;
          });
        } else {
          return null;
        }
      },
      points() {
        return this.userinfo.points + this.userinfo.overdraft_limit > this.info.poundage;
      },
    },
    watch: {
      async activeKey(a, b) {
        if (a == 3) {
          if (this.qrcodeurl == '') {
            this.getQrcode();
          } else if (b != a) {
            this.Check();
          }
        } else {
          this.CancleCheck();
        }
        if (a == 4) {
          this.userinfo = await userinfo2();
          console.log(this.userinfo);
        }
      },
      visible(a) {
        console.log(a);
        if (!a && this.ti) {
          this.CancleCheck();
        }
        if (a && this.activeKey == 3) {
          this.Check();
        }
      },
    },
    async mounted() {
      this.banklist = (await banks({ current: -1 })).data || {};
    },

    methods: {
      reload() {
        this.getQrcode();
      },
      Check() {
        this.ti = setInterval(this.check, 1000);
      },
      CancleCheck() {
        clearInterval(this.ti);
        this.ti = null;
      },
      async getQrcode() {
        if (this.qrcodeurl) {
          this.$refs['qrcode'].innerHTML = '';
        }
        this.qrcodeurl = await contractThirdPay(this.info.id);
        this.qrcodetime = dayjs().add(20, 'minute').format('YYYY-DD-MM HH:mm:ss');
        this.qrcode = new QRCode(this.$refs['qrcode'], {
          text: this.qrcodeurl,
          width: 300,
          height: 300,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.Check();
      },
      async check() {
        const res = await contractCheck(this.info.id);
        if (res) {
          this.$message.success('支付成功');
          clearInterval(this.ti);
          this.ti = null;
          this.$emit('ok');
          this.$emit('cancel');
        }
      },
      async pointspay() {
        this.payloading = true;
        await contractPointPay(this.info.id);
        this.payloading = false;
        this.$emit('ok');
        this.$emit('cancel');
      },
      gopay() {
        window.open(this.bank ? this.bank.link : '', 'target', '_blank');
      },
    },
  };
</script>
